import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '@/components/layout';
import { Card, Input, Textarea, Button } from '@/components/atoms';
import { useBackButton, useMainButton } from '@/hooks';
import { reverse } from '@/api';
import { toast } from '@/components/atoms/Toast';
import { logger } from '@/utils/logger';
import { mockCategories } from '@/mocks/categories';
import { mockCities } from '@/mocks/cities';
import styles from './pages.module.css';

export function ReverseRequestNewPage(): JSX.Element {
  useBackButton();
  const navigate = useNavigate();
  const [draft, setDraft] = useState({
    category_slug: 'repair',
    city_slug: 'lisbon',
    description: '',
    budget_eur_max: '',
    desired_date: '',
    is_anonymous: false,
  });

  const submit = async (): Promise<void> => {
    if (!draft.description.trim()) {
      toast.error('Опиши, що треба');
      return;
    }
    try {
      const res = await reverse.createReverseRequest({
        category_slug: draft.category_slug,
        city_slug: draft.city_slug,
        description: draft.description,
        budget_eur_max: draft.budget_eur_max ? Number(draft.budget_eur_max) : undefined,
        desired_date: draft.desired_date || undefined,
        is_anonymous: draft.is_anonymous,
      });
      if (res.status === 'moderated_out') {
        toast.error(res.moderation_note ?? 'Запит відхилено модерацією');
        return;
      }
      toast.success('Опубліковано');
      navigate(`/board/${res.id}`);
    } catch (err) {
      logger.error('Reverse create failed', err);
      toast.error('Не вдалось опублікувати');
    }
  };

  useMainButton({ text: 'Опублікувати', onClick: submit });

  return (
    <Layout title="Новий запит">
      <Card>
        <div className={styles.formStack}>
          <label>
            <span className={styles.note}>Розділ</span>
            <select
              value={draft.category_slug}
              onChange={(e) => setDraft({ ...draft, category_slug: e.target.value })}
              style={{ width: '100%', padding: 12, borderRadius: 12, background: 'var(--bg)' }}
            >
              {mockCategories.map((c) => (
                <option key={c.slug} value={c.slug}>
                  {c.icon} {c.name_ua}
                </option>
              ))}
            </select>
          </label>
          <label>
            <span className={styles.note}>Місто</span>
            <select
              value={draft.city_slug}
              onChange={(e) => setDraft({ ...draft, city_slug: e.target.value })}
              style={{ width: '100%', padding: 12, borderRadius: 12, background: 'var(--bg)' }}
            >
              {mockCities.map((c) => (
                <option key={c.slug} value={c.slug}>
                  {c.name_ua}
                </option>
              ))}
            </select>
          </label>
          <Textarea
            label="Опис"
            value={draft.description}
            onChange={(e) => setDraft({ ...draft, description: e.target.value })}
            rows={4}
            maxLength={2000}
            placeholder="Що треба зробити, бажано конкретно."
          />
          <div className={styles.formRow}>
            <Input
              label="Бюджет (€)"
              type="number"
              value={draft.budget_eur_max}
              onChange={(e) => setDraft({ ...draft, budget_eur_max: e.target.value })}
            />
            <Input
              label="Дата"
              type="date"
              value={draft.desired_date}
              onChange={(e) => setDraft({ ...draft, desired_date: e.target.value })}
            />
          </div>
          <label style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input
              type="checkbox"
              checked={draft.is_anonymous}
              onChange={(e) => setDraft({ ...draft, is_anonymous: e.target.checked })}
            />
            Анонімний запит (до акцепту спеціаліста)
          </label>
          <Button onClick={submit} fullWidth>
            Опублікувати
          </Button>
        </div>
      </Card>
    </Layout>
  );
}
